import { memo } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import "./TotalNote.scss";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const TotalNote = ({ showChildrenNote }) => {
	if (!showChildrenNote) {
		return null;
	}

	return (
		<Typography variant={TYPOGRAPHY_VARIANTS.SMALL} className="total-note" component="p">
			<FormattedMessage id="price.detail.children.discount.note" />
		</Typography>
	);
};

TotalNote.propTypes = {
	showChildrenNote: PropTypes.bool,
};

export default memo(TotalNote);
